//@ts-ignore
import { toast } from "react-toastify";
import moment from "moment-jalaali";
import "moment/locale/fa";
import { BankAssetUrl, Banks } from "./Constants";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { DateObject } from "react-multi-date-picker";
import { translator } from "./translator";

export const toSelectOptions = (_options: { [key: string]: string }) => {
  const options = Object.keys(_options).map((key) => {
    return {
      label: _options[key],
      value: key,
    };
  });

  return options;
};

export function findBank(bankName: string) {
  return Banks.filter((item) => item.icon === bankName)[0];
}

export function findBankLogo(bankName: string): string {
  const bank = findBank(bankName);

  if (bank) return BankAssetUrl + bank.icon + ".svg";

  return "";
}

export function bankColor(bankName: string): Object {
  const bank = findBank(bankName);
  if (bank && bank.colors) return bank.colors;

  return {};
}

export function moneyFormat(number: number | string): string {
  number = moneyFormatInt(number);
  let money = new Intl.NumberFormat("en-US", {
    style: "decimal",
  }).format(number);

  if (money === "NaN") return "";

  if (money[0] === "0") {
    money = money.substring(1);
  }

  return money;
}

export function moneyFormatInt(value: string | number): number {
  value = value + "";
  return parseInt(value.replace(/\D/g, ""));
}

export function toNumber(value: string | number) {
  value = value + "";
  return value.replace(/[^\d]/g, "");
}

export const invoiceBuilderCal = {
  calcDiscount: (amount: number, discount: number, isToamn = true) => {
    if (isToamn) amount = amount * 10;

    let value = amount * (discount / 100);

    if (isToamn) value = value / 10;

    return value;
  },
  calcTax: (amount: number, tax: number, isToamn = true) => {
    if (isToamn) amount = amount * 10;

    let value = amount * (tax / 100);

    if (isToamn) value = value / 10;

    return value;
  },
};

export const reorder = (list: any, startIndex: any, endIndex: any) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

// mahan vahdani

// lang translate
// export const translator = (
//   value: string,
// ): string => {
//   if (lang[value]) return lang[value];
//   return value;
// };

// regex implementation
export const applyRegex = (value: string, regex: RegExp): string => {
  // const newValue = value
  //   ?.split("")
  //   ?.filter((char) => regex.test(char))
  //   ?.join("");

  if (value == null) return "";
  let newValue = "";
  for (let char of value) {
    if (regex.test(newValue + char)) {
      newValue += char;
    }
  }
  return newValue;
};

// time convertor
export const timeConverter = (
  timestamp: string,
  type?: "date" | "time" | "fullDate"
): string => {
  if (!timestamp) return "";

  moment.loadPersian();

  const fullDate = moment(timestamp).locale("fa").format("dddd jD jMMMM jYYYY");

  const date = moment(timestamp).locale("fa").format("jD jMMMM jYYYY");

  const time = moment(timestamp).locale("fa").format("[ساعت] HH:mm");

  const dateAndTime = moment(timestamp)
    .locale("fa")
    .format("jD jMMMM jYYYY [ساعت] HH:mm");

  if (type === "date") return date;
  if (type === "time") return time;
  if (type === "fullDate") return fullDate;
  return dateAndTime;
};

// current time
export const currentTime = (type?: "iso" | "date" | "time" | "fullDate") => {
  const currentDate = new Date().toISOString();

  if (type === "iso") return currentDate;
  return timeConverter(currentDate, type);
};

export function toJalali(date: string, format: string = "YYYY/MM/DD") {
  const _date: DateObject = new DateObject(date).convert(persian, persian_fa);

  return _date.format(format);
}

export function toJalaliHuman(date: string, withMinute: boolean = false) {
  return toJalali(date, withMinute ? "DD MMMM YYYY HH mm" : "DD MMMM YYYY");
}

export function toGregorian(jalaliDate: string) {
  jalaliDate = perToEnDigits(jalaliDate);
  return perToEnDigits(
    moment(jalaliDate, "jYYYY-jMM-jDD").format("YYYY-MM-DD")
  );
}

// table cell
interface TblCellProps {
  data: any;
  langConvert?: boolean;
  timeConvert?: boolean;
}

export const TblCell: React.FC<TblCellProps> = (props) => {
  if (props.data) {
    if (props.langConvert) {
      return translator(props.data);
    } else if (props.timeConvert && typeof props.data === "string") {
      return timeConverter(props.data);
    } else {
      return props.data;
    }
  } else {
    return "―";
  }
};

// number convertor
export const engToPerDigits = (input: string): string => {
  if (!input) return "";

  const englishDigits: string[] = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
  ];
  const persianDigits: string[] = [
    "۰",
    "۱",
    "۲",
    "۳",
    "۴",
    "۵",
    "۶",
    "۷",
    "۸",
    "۹",
  ];

  let output = "";

  for (let i = 0; i < input?.length; i++) {
    const char = input[i];
    const index = englishDigits.indexOf(char);
    output += index !== -1 ? persianDigits[index] : char;
  }

  return output;
};

export const perToEnDigits = (input: string): string => {
  if (!input) return "";

  const englishDigits: string[] = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
  ];
  const persianDigits: string[] = [
    "۰",
    "۱",
    "۲",
    "۳",
    "۴",
    "۵",
    "۶",
    "۷",
    "۸",
    "۹",
  ];

  let output = "";

  for (let i = 0; i < input?.length; i++) {
    const char = input[i];
    const index = persianDigits.indexOf(char);
    output += index !== -1 ? englishDigits[index] : char;
  }

  return output;
};

export const idGenerator = (): number => {
  // create new id
  const timestamp: number = new Date().getTime();
  const shortenedTimestamp: number = timestamp % 100000;
  const randomNumber: number = Math.round(Math.random() * 1000000);
  const newID: number = shortenedTimestamp + randomNumber;

  return newID;
};

export const stringAvatar = (name: string, family: string) => {
  return {
    children: `${name.split(" ")[0][0]}.${family.split(" ")[0][0]}`,
  };
};

export const handleServerErrors = (
  error: any,
  setErrors?: (errors: any) => void
) => {
  const response = error?.data?.response;
  const hasError = response?.data || response?.message;

  if (hasError) {
    typeof hasError === "string"
      ? toast.error(response.message)
      : setErrors
      ? setErrors(hasError)
      : Object.keys(hasError).forEach((err) => toast.error(hasError[err]));
  } else {
    toast.error("خطای غیرمنتظره رخ داده است.");
  }
};
